'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  border-bottom: 1px ', ' solid;\n'], ['\n  border-bottom: 1px ', ' solid;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  z-index: 1000;\n  top: 0px;\n  right: 0px;\n  transform-origin: right center 0px;\n  opacity: 1;\n  transform: scaleY(1);\n  width: 100%;\n\theight: auto;\n\tpadding: 8px 0px 0px 0px !important;\n\n  p {\n    padding: 0 !important;\n  }\n\n  p:hover {\n    background-color: ', ';\n  }\n'], ['\n  z-index: 1000;\n  top: 0px;\n  right: 0px;\n  transform-origin: right center 0px;\n  opacity: 1;\n  transform: scaleY(1);\n  width: 100%;\n\theight: auto;\n\tpadding: 8px 0px 0px 0px !important;\n\n  p {\n    padding: 0 !important;\n  }\n\n  p:hover {\n    background-color: ', ';\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin-left: 0px;\n  padding: 0px 16px;\n  position: relative;\n  display: flex;\n  place-content: space-between;\n  text-align: left;\n  border: 10px;\n  background-image: none;\n  background-position: initial;\n  background-size: initial;\n  background-repeat: initial;\n  background-attachment: initial;\n  background-origin: initial;\n  background-clip: initial;\n  box-sizing: border-box;\n  display: block;\n  font-family: Roboto, sans-serif;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  cursor: pointer;\n  text-decoration: none;\n  outline: none;\n  transform: translate3d(0px, 0px, 0px);\n  color: rgba(0, 0, 0, 0.87);\n  font-size: 1em;\n  line-height: 35px;\n  position: relative;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  white-space: nowrap;\n\n  &:hover {\n    background-color: ', ';\n  }\n'], ['\n  margin-left: 0px;\n  padding: 0px 16px;\n  position: relative;\n  display: flex;\n  place-content: space-between;\n  text-align: left;\n  border: 10px;\n  background-image: none;\n  background-position: initial;\n  background-size: initial;\n  background-repeat: initial;\n  background-attachment: initial;\n  background-origin: initial;\n  background-clip: initial;\n  box-sizing: border-box;\n  display: block;\n  font-family: Roboto, sans-serif;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  cursor: pointer;\n  text-decoration: none;\n  outline: none;\n  transform: translate3d(0px, 0px, 0px);\n  color: rgba(0, 0, 0, 0.87);\n  font-size: 1em;\n  line-height: 35px;\n  position: relative;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  white-space: nowrap;\n\n  &:hover {\n    background-color: ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Divider = _styledComponents2.default.div(_templateObject, _color2.default.purple_main);

var Menu = _styledComponents2.default.div(_templateObject2, _color2.default.purple_accent);

var MenuItem = _styledComponents2.default.div(_templateObject3, _color2.default.purple_accent);

var MozartMenu = function (_Component) {
  _inherits(MozartMenu, _Component);

  function MozartMenu(props) {
    _classCallCheck(this, MozartMenu);

    var _this = _possibleConstructorReturn(this, (MozartMenu.__proto__ || Object.getPrototypeOf(MozartMenu)).call(this, props));

    _this.state = {
      open_item: true,
      current_menu: null
    };
    return _this;
  }

  _createClass(MozartMenu, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var currentMenu = '';
      if (this.state.current_menu === null) {
        if (nextProps.current) {
          currentMenu = nextProps.current;
        } else {
          currentMenu = nextProps.data ? nextProps.data[0].text : null;
        }
        this.setState({ current_menu: currentMenu });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(data) {
      this.setState({
        current_menu: data.text
      });
      this.props.onChange(data.text, data.pannel);
    }
  }, {
    key: 'getUnderline',
    value: function getUnderline(index) {
      return _react2.default.createElement(Divider, { key: index });
    }
  }, {
    key: 'getMenuItem',
    value: function getMenuItem() {
      var _this2 = this;

      var data = this.props.data;

      var DATA = [];
      var NESTEDDATA = [];
      if (data) {
        data.forEach(function (menuItem, index) {
          var key = menuItem.text.split(' ').join('_').toLowerCase();
          if (menuItem.children === null) {
            DATA.push(_react2.default.createElement(
              MenuItem,
              {
                onClick: _this2.onChange.bind(_this2, menuItem),
                key: key
              },
              _react2.default.createElement(
                'div',
                null,
                menuItem.icon ? menuItem.icon : '',
                menuItem.text
              )
            ));
          } else {
            NESTEDDATA = _this2.getNestedItem(menuItem);
            DATA = DATA.concat(NESTEDDATA);
          }
          if (data.length !== 1) {
            DATA.push(_this2.getUnderline(index));
          }
        });
      }

      return DATA;
    }
  }, {
    key: 'getNestedItem',
    value: function getNestedItem(menuItem) {
      var _this3 = this;

      var key = menuItem.text.split(' ').join('_').toLowerCase();
      var DATA = [];
      var children = [];
      menuItem.children.forEach(function (childrenItem, childrenIndex) {
        var childKey = childrenItem.text.split(' ').join('_').toLowerCase();
        var style = { fontSize: '1em', paddingLeft: '35px', lineHeight: '30px' };
        if (_this3.state.open_item) {
          style.display = 'inherit';
        } else {
          style.display = 'none';
        }
        children.push(_react2.default.createElement(
          MenuItem,
          {
            onClick: _this3.onChange.bind(_this3, childrenItem),
            key: childKey + '_' + childrenIndex,
            ref: 'menuitem',
            style: style
          },
          _react2.default.createElement(
            'div',
            null,
            menuItem.icon ? menuItem.icon : '',
            childrenItem.text
          )
        ));
      });
      DATA.push(_react2.default.createElement(
        MenuItem,
        {
          onClick: function onClick() {
            _this3.setState({ open_item: !_this3.state.open_item });
          },
          key: key,
          style: { fontSize: '1em' }
        },
        _react2.default.createElement(
          'p',
          { style: { margin: '0px', padding: '0px' } },
          _react2.default.createElement(
            'span',
            null,
            menuItem.icon ? menuItem.icon : '',
            menuItem.text
          ),
          _react2.default.createElement('span', { className: 'icon-DownAlternative', style: { marginLeft: '10px', fontSize: '0.6em', color: '#000 !important' } })
        )
      ));
      if (this.state.open_item) {
        DATA.push(this.getUnderline('divider_' + key));
      }
      DATA.push(children);
      return DATA;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          themeId = _props.themeId;

      style.width = style.width ? style.width : '100%';

      return _react2.default.createElement(
        Menu,
        {
          'data-qa': this.props.testId,
          style: style,
          value: this.state.current_menu,
          selectedMenuItemStyle: { backgroundColor: '#F5F4FF', color: '#000' },
          'data-theme': themeId
        },
        this.getMenuItem()
      );
    }
  }]);

  return MozartMenu;
}(_react.Component);

MozartMenu.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  style: _propTypes2.default.object,
  current: _propTypes2.default.string,
  data: _propTypes2.default.array // {text: children: pannel: icon: }
};
MozartMenu.defaultProps = {
  data: [],
  style: {},
  testId: 'MozartMenu',
  themeId: 'MozartMenu'
};
exports.default = MozartMenu;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartNavigation/MozartMenu/MozartMenu.js
// module id = 2115
// module chunks = 1